export default {
  getConference(state) {
    return state.conference
  },

  getChatLogs(state) {
    return state.chatLogs
  }
}
